var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.988,10a2.988,2.988,0,1,0,2.988,2.988A2.988,2.988,0,0,0,18.988,10Zm0,4.482a1.494,1.494,0,1,1,1.494-1.494A1.494,1.494,0,0,1,18.988,14.482Z",
    transform: "translate(-10.988 -7.136)",
    fill: "#9d9d9d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,2a7.964,7.964,0,1,0,5.668,2.332A8,8,0,0,0,10,2ZM5.564,14.8A9.6,9.6,0,0,1,10,13.636,9.6,9.6,0,0,1,14.436,14.8a6.509,6.509,0,0,1-8.873,0Zm9.854-1.127h0A11.164,11.164,0,0,0,10,12.182a11.164,11.164,0,0,0-5.418,1.491h0A6.436,6.436,0,0,1,3.455,10a6.545,6.545,0,0,1,13.091,0,6.436,6.436,0,0,1-1.127,3.673Z",
    transform: "translate(-2 -2)",
    fill: "#9d9d9d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentInfo);
export default __webpack_public_path__ + "static/media/agentInfo.d5c3d1956ead8728f5c2c6caf172e873.svg";
export { ForwardRef as ReactComponent };